(function () {
	'use strict';

	angular.module('mx.components').component('mxTabs', {
		bindings: {
			tabs: '<?',
			parentControllerAs: '@',
			disabled: '<',
			selectedTabName: '=?selectedTab',
		},
		templateUrl: 'mx-tabs/mx-tabs.html',
		controller: MxTabsCtrl,
		controllerAs: '__$vm',
	});

	MxTabsCtrl.$inject = ['$scope'];
	function MxTabsCtrl($scope) {
		var vm = this;
		var selectedTabName;
		vm.tabsFilter = function (item) {
			return item.visible !== false;
		};
		vm.$onInit = function () {
			vm.tabs
				.sort(function (a, b) {
					return (a.position || 0) - (b.position || 0);
				})
				.forEach(function (tab) {
					tab.disabled = vm.disabled || (typeof tab.disabled === 'string' ? tab.disabled.toLowerCase() === 'true' : !!tab.disabled);
				});
			setTabName(vm.selectedTabName);

			Object.defineProperty(vm, 'selectedTabName', {
				get: function () {
					return selectedTabName;
				},
				set: setTabName,
			});

			initScope();
		};

		function initScope() {
			if (vm.parentControllerAs) {
				$scope[vm.parentControllerAs] = $scope.$parent[vm.parentControllerAs];
			} else {
				$scope.dataModel = $scope.$parent;
			}
			$scope.item = $scope.$parent.item;
		}

		$scope.$watch('__$vm.selectedIndex', changeTabIndex);

		function setTabName(value) {
			if (value && value !== selectedTabName) {
				var i = 0;
				vm.tabs.some(function (tab) {
					if (tab.name === value) {
						selectedTabName = value;
						vm.selectedIndex = i;
						return true;
					}
					i++;
				});
			}
		}

		function changeTabIndex(index) {
			if (typeof index === 'number') {
				var tab = vm.tabs?.filter((tab) => tab.visible !== false)[+index];
				selectedTabName = tab ? tab.name : '';
			}
		}
	}
})();
